<script lang="ts">
	import { onMount } from 'svelte';
	import { push } from 'svelte-spa-router';
	import Navbar from '../components/Navbar.svelte';
	import { appStore } from '../stores/appStore';
	import { get } from 'svelte/store';
	import DashboardMetrics from '../components/dashboard/DashboardMetrics.svelte';
	import SessionStats from '../components/dashboard/SessionStats.svelte';
	import TopRepositories from '../components/dashboard/TopRepositories.svelte';
	import AdminSidebar from '../components/dashboard/AdminSidebar.svelte';

	let isAdmin = false;
	let loading = true;

	onMount(async () => {
		const profile = get(appStore).profile;

		// Check if user is logged in
		if (!profile) {
			push('/login');
			return;
		}

		// Check if user is admin
		if (profile.userRole !== 'admin') {
			push('/');
			return;
		}

		isAdmin = true;
		loading = false;
	});
</script>

<Navbar />

<div class="dashboard-wrapper">
	{#if loading}
		<div class="loading">
			<p>Loading...</p>
		</div>
	{:else if isAdmin}
		<div class="dashboard-layout">
			<AdminSidebar />

			<div class="dashboard-main">
				<div class="dashboard-header">
					<h1>Analytics Dashboard</h1>
					<p class="subtitle">Welcome back, here's what's happening with your platform today</p>
				</div>

				<DashboardMetrics />

				<div class="dashboard-grid">
					<div class="grid-item full-width">
						<SessionStats />
					</div>

					<div class="grid-item">
						<TopRepositories />
					</div>
				</div>
			</div>
		</div>
	{/if}
</div>

<style>
	.dashboard-wrapper {
		min-height: 100vh;
		background: var(--bg-primary, #0d1117);
		color: var(--text-primary, #e6edf3);
	}

	.loading {
		display: flex;
		justify-content: center;
		align-items: center;
		min-height: 80vh;
		font-size: 1.2rem;
	}

	.dashboard-layout {
		display: flex;
		min-height: calc(100vh - 60px);
	}

	.dashboard-main {
		flex: 1;
		padding: 2rem;
		overflow-y: auto;
	}

	.dashboard-header {
		margin-bottom: 2rem;
	}

	.dashboard-header h1 {
		font-size: 2rem;
		font-weight: 600;
		margin: 0 0 0.5rem 0;
		color: var(--text-primary, #e6edf3);
	}

	.subtitle {
		color: var(--text-secondary, #8b949e);
		margin: 0;
		font-size: 0.9375rem;
	}

	.dashboard-grid {
		margin-top: 2rem;
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
		gap: 1.5rem;
	}

	.grid-item.full-width {
		grid-column: 1 / -1;
	}

	@media (max-width: 768px) {
		.dashboard-main {
			padding: 1rem;
		}

		.dashboard-grid {
			grid-template-columns: 1fr;
		}
	}
</style>
